import { render, staticRenderFns } from "./ProductsSuggestionByProduct.vue?vue&type=template&id=0cd9690a&scoped=true"
import script from "./ProductsSuggestionByProduct.vue?vue&type=script&lang=js"
export * from "./ProductsSuggestionByProduct.vue?vue&type=script&lang=js"
import style0 from "./ProductsSuggestionByProduct.vue?vue&type=style&index=0&id=0cd9690a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd9690a",
  null
  
)

export default component.exports